import {Box, Button, Divider, Flex, Text} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {colors} from 'components/providers';
import {Checkbox} from 'components/shared';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {ICustomerAddress} from 'types';
import ImageUI from 'ui/ImageUI';
import {getAddressDetails, getStreetNameFromAddress} from 'utils/addresses';

interface Props {
  address: ICustomerAddress;
  onSelect: (value: ICustomerAddress) => void;
  isSelected: boolean;
  onEdit: (addressId: number | string) => void;
  withBorder?: boolean;
  t: (term: TranslationKeys) => string;
}

const iconsFolderPath = '/icons/address-type';

export const AddressItem: FC<Props> = ({address, onSelect, isSelected, onEdit, withBorder = false, t}) => {
  const {id, address: addressLocation} = address;
  const icon = `${iconsFolderPath}/${`/pin-icon.svg`}`;

  const handleEditButton = () => {
    if (id) {
      onEdit(id);
    }
  };

  const handleSelect = () => {
    onSelect(address);
  };

  return (
    <Box border={withBorder ? '1px solid' : ''} borderColor={colors.borderGray} borderRadius="16px">
      <IconBlock icon={icon} position="relative">
        <Flex alignItems="flex-start">
          <Flex flexDirection="column" pr="30px" maxW="280px">
            <Text fontSize="14px" fontWeight="600" mb="5px">
              {getStreetNameFromAddress(addressLocation)}
            </Text>
            <Text fontSize="14px" fontWeight="500" color={colors.textGray}>
              {getAddressDetails(address.address, t)}
            </Text>
            {address.customer_address_comment && (
              <Text fontSize="14px" fontWeight="500" color={colors.textGray} pt="10px">
                *{address.customer_address_comment}
              </Text>
            )}
          </Flex>
          <Button
            onClick={handleEditButton}
            borderRadius="9999px"
            alignSelf="flex-start"
            minW="30px"
            h="30px"
            p="0"
            position="absolute"
            top="1rem"
            right="1rem"
          >
            <ImageUI src="/edit-icon.svg" alt="icon" />
          </Button>
        </Flex>
        <Divider my="10px" />
        <Flex justifyContent="flex-start" alignItems="center">
          <Checkbox variant="circle" isChecked={isSelected} onChange={handleSelect}>
            <Text fontSize="14px" fontWeight="600">
              {t('I_WORK_HERE')}
            </Text>
          </Checkbox>
        </Flex>
      </IconBlock>
    </Box>
  );
};
